import { LinkItem } from '@occc-app/design-system';
import { ProductGroupFragment } from '@occc/graphql';
import { routeCreator } from '@occc-app/routes/ProductGroup/utils';
import { routeCreator as programManagementRouteCreator } from '@occc-app/routes/ProgramManagement/utils';

export const getProductGroupPageHeaderLinks = (
  productGroup: ProductGroupFragment | null | undefined,
): LinkItem[] => {
  if (!productGroup) {
    return [];
  }

  return [
    { to: programManagementRouteCreator.base(), label: 'Program Management' },
    { to: routeCreator.list(), label: 'Product Groups' },
    {
      key: routeCreator.details(productGroup.id),
      label: productGroup.name,
    },
  ];
};
